import { Injectable } from "@angular/core";
import {
  Resolve,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  Router
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import { LikedinService } from "./likedin.service";
import { InfineScrollLoaderService } from "./shared/services/infine-scroll-loader.service";
import swal from "sweetalert2";
@Injectable()
export class LinkedinResolverService implements Resolve<any> {
  constructor(
    private router: ActivatedRoute,
    private route: Router,
    private linkedInService: LikedinService,
    private loaderService: InfineScrollLoaderService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const code = this.getQueryStringValue("code");
    if (code) {
      this.loaderService.display(true);
      const roleCode = localStorage.getItem('linkedInUserType');
      this.linkedInService
        .getLinkedInUserDetails(code)
        .subscribe((resp: any) => {
          let k = resp;
          let t =  k["linkedInUserData"];
          let emailData;
          if (! k["linkedInUserEmailData"].elements) {
            emailData = null;
          } else {
            emailData = k["linkedInUserEmailData"].elements.length ? k["linkedInUserEmailData"]["elements"][0]["handle~"]["emailAddress"]: null;

          }
          if (emailData) {
            t.emailAddress = emailData;
          }
          this.linkedInService.setUserDetails(t);
        this.navigateToPage(roleCode);
        this.loaderService.display(false);
        }, error => {
          this.navigateToPage(roleCode);
          this.loaderService.display(false);
          swal("Info", 'Sorry! Something went wrong please try again later', "info");
        });
    } else {
      return null;
    }
  }

  navigateToPage(role: string) {
   if (role === 'tech_vendor') {
    this.route.navigate(["/account/registration-tech-vendor"]);
    localStorage.removeItem('linkedInUserType');
   } else if (role === 'tech_buyer') {
    this.route.navigate(["/account/registration-tech-buyer"]);
    localStorage.removeItem('linkedInUserType');
   } else if (role === 'tech_analyst') {
    this.route.navigate(["/account/registration-tech-analyst"]);
    localStorage.removeItem('linkedInUserType');
   } else {
    return null;
   }
  }

  getQueryStringValue(key) {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/linkedin-resolver.service.ts